import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">

          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center">
                <i className="ri-movie-2-line text-2xl text-primary-500"></i>
              </div>
              <span className="text-xl font-heading text-gradient-primary">
                春色影视
              </span>
            </div>
            <p className="text-sm text-foreground-500 leading-relaxed">
              高清影视免费在线观看平台，提供最新电影、电视剧、综艺、动漫等全类型影视资源，每日更新，流畅不卡顿。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#quick-links" className="cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/category/movie', label: '电影专区' },
                { to: '/category/tv', label: '电视剧专区' },
                { to: '/category/variety', label: '综艺专区' },
                { to: '/category/anime', label: '动漫专区' },
              ].map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#about-links" className="cursor-pointer">关于我们</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { to: '/about', label: '品牌介绍' },
                { to: '/about', label: '用户口碑' },
                { to: '/about', label: '联系方式' },
              ].map((item) => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200 cursor-pointer"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              <a href="#disclaimer" className="cursor-pointer">免责声明</a>
            </h4>
            <p className="text-sm text-foreground-500 leading-relaxed">
              本站所有资源均来自互联网公开分享，仅供测试和学习交流使用。请在下载后24小时内删除，支持正版，尊重版权。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-600">
            &copy; {new Date().getFullYear()} 春色影视 - 高清影视免费在线观看。本站为非盈利性质，仅供学习交流。
          </p>
          <div className="flex items-center gap-4">
            <a href="#wechat" className="text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微信">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </span>
            </a>
            <a href="#weibo" className="text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="微博">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </span>
            </a>
            <a href="#email" className="text-foreground-600 hover:text-primary-500 transition-colors duration-200 cursor-pointer" aria-label="邮箱">
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}